// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rz+By","overlay":"styles_overlay__Nt1lb"};